import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PolicyRenewalItemQuotationComponent from './PolicyRenewalItemQuotationComponent';
import { RenewalQuotationInsurerPeriodTitle } from 'features/policyRenewal/components/PolicyRenewalStyles';

const PolicyRenewalItemQuotationContainer = ({ quotation, index, fetching, running }) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item container>
        <RenewalQuotationInsurerPeriodTitle>
          {t('Offer.Edit.Comparator.Title', {
            period: quotation && quotation.length ? quotation[0].period : ''
          })}
        </RenewalQuotationInsurerPeriodTitle>
      </Grid>
      <Grid item container xs={12} key={`${index}`} spacing={1}>
        {quotation.map((quotation, index) => (
          <PolicyRenewalItemQuotationComponent quotation={quotation} index={index} key={index} fetching={fetching} running={running} />
        ))}
      </Grid>
    </>
  );
};

PolicyRenewalItemQuotationContainer.propTypes = {
  quotation: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  fetching: PropTypes.bool,
  running: PropTypes.bool
};
export default PolicyRenewalItemQuotationContainer;
